import React from 'react';
import { motion } from 'framer-motion';
import { IMPORTANT_DAYS } from '../utils/importantDays';
import DayCardActions from './DayCardActions';

const ImportantDaysExplanation = ({ currentMonth, dob }) => {
  // Obtener días importantes del mes actual
  const getImportantDaysInMonth = () => {
    const importantDays = [];
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    
    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month, day);
      // Calcular número personal del día usando la misma fórmula que el calendario
      const personalDay = calculatePersonalDay(date, dob);
      
      if (IMPORTANT_DAYS[personalDay]) {
        importantDays.push({
          day: day,
          personalDay: personalDay,
          info: IMPORTANT_DAYS[personalDay]
        });
      }
    }
    
    return importantDays;
  };

  // Función que usa la misma fórmula que el calendario principal
  const calculatePersonalDay = (date, dob) => {
    const sumDigits = (n) => Math.abs(n).toString().split("").reduce((a, b) => a + Number(b), 0);
    const reduceNum = (n) => {
      let x = Math.abs(n);
      while (x >= 10 && x !== 11 && x !== 22) x = sumDigits(x);
      return x;
    };
    
    const personalYear = ({ d, m }, Y) => reduceNum(Y + m + d);
    const PY = personalYear(dob, date.getFullYear());
    const D = date.getDate();
    const M = date.getMonth() + 1;
    
    return reduceNum(PY + D + M);
  };

  const importantDays = getImportantDaysInMonth();

  if (importantDays.length === 0) {
    return null;
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="mt-4 p-4 bg-morado/5 rounded-xl border border-morado/20"
    >
      <h4 className="text-sm font-semibold text-morado mb-3 flex items-center gap-2">
        <span className="text-lg">⭐</span>
        Días Importantes del Mes
      </h4>
      
      <div className="space-y-3">
        {importantDays.map(({ day, personalDay, info }) => (
          <div key={day} className="flex items-start gap-3 p-3 bg-white/70 rounded-lg border border-gray-200">
            <div className="flex-shrink-0">
              <div className="w-8 h-8 rounded-full bg-morado/10 flex items-center justify-center">
                <span className="text-lg">{info.emoji}</span>
              </div>
            </div>
            
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-sm font-semibold text-morado">
                  {day} de {currentMonth.toLocaleDateString('es-ES', { month: 'long' })}
                </span>
                <span className="text-xs bg-morado/10 text-morado px-2 py-0.5 rounded-full font-medium">
                  Día {personalDay}
                </span>
              </div>
              
              <h5 className="text-sm font-medium text-gray-800 mb-1">
                {info.label}
              </h5>
              
              <p className="text-xs text-gray-600 leading-relaxed">
                {info.description}
              </p>
            </div>
            
            {/* Íconos de acción para cada día */}
            <DayCardActions 
              day={day}
              month={currentMonth.getMonth() + 1}
              year={currentMonth.getFullYear()}
              label={info.label}
              description={info.description}
              emoji={info.emoji}
            />
          </div>
        ))}
      </div>
      
      <div className="mt-3 pt-3 border-t border-gray-200">
        <p className="text-xs text-gray-500 text-center">
          💡 Estos días tienen energías especiales que puedes aprovechar para tus objetivos
        </p>
      </div>
      
      {/* Botones generales eliminados por decisión de UX */}
    </motion.div>
  );
};

export default ImportantDaysExplanation;
